import { Controller } from "@hotwired/stimulus"

// Makes a table row behave like a link to `url-value`. Mounted on <tr> so
// the whole row is clickable instead of needing a dedicated View button.
// Cmd/Ctrl/middle-click open in a new tab; clicks on nested interactive
// elements (links, buttons, inputs) fall through to their own handlers.
export default class extends Controller {
  static values = { url: String }

  open(event) {
    if (event.target.closest("a, button, input, textarea, select, label")) return

    if (event.metaKey || event.ctrlKey || event.button === 1) {
      window.open(this.urlValue, "_blank", "noopener")
      return
    }

    window.location.href = this.urlValue
  }
}
